/*
 * Public API Surface of photo-swipe
 */

export * from './lib/photo-swipe.module';
export { PhotoSwipeComponent } from './lib/photo-swipe/photo-swipe.component';
export { PhotoSwipeDirective } from './lib/photo-swipe.directive';
export { PhotoSwipeService } from './lib/photo-swipe.service';
export { PhotoSwipOptions } from './lib/entity/PhotoSwipOptions';
export { PhotoSwipeFigureSlide, PhotoSwipeHTMLSlide, PhotoSwipeSlide } from './lib/entity/PhotoSwipeSlide';
export { PhotoSwipeFigureSlideDownLoadData } from './lib/entity/PhotoSwipeFigureSlideDownLoadData';
export * from './lib/util';